import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState, Children, isValidElement, cloneElement, useEffect, } from "react";
import { useMedia } from "../../utils/use-media";
import { useTheme } from "styled-components";
import { TilesContainer } from "./Tiles.styles";
export function generatePreviewId(isPreview, dataPreviewId) {
    if (isPreview) {
        return {
            "data-preview-id": dataPreviewId,
        };
    }
    return {};
}
export const Tiles = ({ children, type, onSelect, gap = "1.5rem", initialSelectedIndex = 0, isPreview, previewId, fallbackImg, backgroundColor, previewIdExtractor, }) => {
    const theme = useTheme();
    const [selectedTileIndex, setSelectedTileIndex] = useState(initialSelectedIndex);
    const breakPoint = useMedia([
        theme.device.xlarge,
        theme.device.large,
        theme.device.medium,
        theme.device.small,
    ], ["xlarge", "large", "medium", "small"], "large");
    const handleOnSelect = (index) => {
        setSelectedTileIndex(index);
        if (onSelect) {
            onSelect(index);
        }
    };
    useEffect(() => {
        setSelectedTileIndex(initialSelectedIndex);
    }, [initialSelectedIndex]);
    const results = Children.map(children, (child, index) => {
        if (isValidElement(child)) {
            const props = {
                key: String(index),
                gap,
                breakPoint,
                isPreview,
                fallbackImg,
                backgroundColor,
                selected: false,
                onSelect: () => { },
                "data-preview-id": isPreview && typeof previewIdExtractor === "function"
                    ? previewIdExtractor(child, index)
                    : undefined,
            };
            if (type === "productive") {
                props.selected = index === selectedTileIndex;
                props.onSelect = () => handleOnSelect(index);
            }
            return cloneElement(child, props);
        }
        return null;
    });
    return (_jsx(TilesContainer, Object.assign({ "data-preview-id": previewId }, generatePreviewId(isPreview, previewId), { gap: gap, type: type }, { children: _jsx(_Fragment, { children: results.filter(Boolean) }) })));
};
